import { Input } from "antd";
import { Form } from "antd";
import { Controller } from "react-hook-form";
import { InputTextProps } from "./types";
import { Text } from "../Text";
import { StyledFlex } from "./style";
import React from "react";
import colors from "theme/colors.module.scss";

// dopuszcza tylko standardowe znaki drukowalne ASCII oraz polskie znaki diakrytyczne,
// odrzucając m.in. znaki z generatorów "fancy text", emoji i zalgo
const ALLOWED_CHARS_REGEX = /[^\x20-\x7EąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/g;

const sanitizeValue = (value: string) => value.replace(ALLOWED_CHARS_REGEX, "");

export const AntInput = ({
  componentKey,
  name,
  control,
  label,
  placeholder,
  value,
  type = "text",
  onChange,
  autocomplete = "on",
  disabled,
  sanitizeInput = false,
  blockPaste = false,
  }: InputTextProps) => {
  const renderInput = () => {
    if (type === "password") {
      return <Input.Password
        placeholder={placeholder}
        size="large"
        defaultValue={value}
        onChange={onChange}
        key={componentKey}
        autoComplete={autocomplete}
        disabled={disabled}
      />;
    }
    return <Input
      placeholder={placeholder}
      type={type}
      size="large"
      defaultValue={value}
      onChange={onChange}
      key={componentKey}
      autoComplete={autocomplete}
      disabled={disabled}
    />;
  };

  return (
    <StyledFlex vertical>
      <Text $textVariant="labelBold" $textColor='text300'>{label}</Text>
      <Form.Item>
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState: { error } }) => {
            const extraProps = {
              ...(sanitizeInput && {
                onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                  field.onChange(sanitizeValue(e.target.value));
                },
              }),
              ...(blockPaste && {
                onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => {
                  e.preventDefault();
                },
              }),
            };
            return (
              <>
                {React.cloneElement(renderInput(), { ...field, ...extraProps })}
                {error && <span style={{ color: colors.accentRed500 }}>{error.message}</span>}
              </>
            );
          }}
        />
      </Form.Item>
    </StyledFlex>
  );
};
